import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { CoordinateSystem, Shapes } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const shapefilesExportUrl = (contractIds, coordinateSystem) =>
  `${environment.apiUrl}/shapefiles/export/${contractIds}?coordinateSystem=${coordinateSystem}`;
const shapefilesExportHistoricUrl = coordinateSystem =>
  `${environment.apiUrl}/shapefiles/export/historic?coordinateSystem=${coordinateSystem}`;
const shapefilesImportRwsUrl = `${environment.apiUrl}/shapefiles/import/rws`;
const shapefilesImportFcdUrl = contractId => `${environment.apiUrl}/shapefiles/import/fcd/${contractId}`;

@Injectable()
export class ShapefileService {
  constructor(private readonly httpService: HttpService) {}

  downloadShapefile(contractIds: number[], coordinateSystem: CoordinateSystem): Observable<any> {
    return this.httpService.post(shapefilesExportUrl(contractIds, coordinateSystem), null);
  }

  downloadHistoricShapefile(coordinateSystem): Observable<any> {
    return this.httpService.post(shapefilesExportHistoricUrl(coordinateSystem), null);
  }

  importRwsShapefile(shapes: Shapes): Observable<any> {
    const formData: FormData = new FormData();

    for (const fileField of Object.keys(shapes)) {
      if (fileField.startsWith('file_')) {
        const shortName = fileField.substr('file_'.length);
        formData.append(shortName, shapes[fileField]);
      }
    }
    return this.httpService.postFile(
      shapefilesImportRwsUrl,
      formData,
      this.httpService.headersWithCredentialsWithoutContentType()
    );
  }

  importFcdShapefile(contractId: string, shapes: Shapes): Observable<any> {
    const formData: FormData = new FormData();

    for (const fileField of Object.keys(shapes)) {
      if (fileField.startsWith('file_')) {
        const shortName = fileField.substr('file_'.length);
        formData.append(shortName, shapes[fileField]);
      }
    }
    return this.httpService.postFile(
      shapefilesImportFcdUrl(contractId),
      formData,
      this.httpService.headersWithCredentialsWithoutContentType()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shapefile.service.ts